/**
 * Enum values for column's content alignment setting values.
 *
 * NB: Same as in DataTableColumn.php!
 */
export enum ColumnAlignment {
  LEFT = 'left',
  RIGHT = 'right',
}
